import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../../../environments/environment';
import { HttpClient, HttpParams } from '@angular/common/http';
import { ResponseModel } from '../../../auth/_models/response.model';
import { PagedResponseModel } from '@models/Generic/paged-response.model';
import { JoinGroupResponseModel } from '../../_models/group-request.model';
import { UserListModel } from '../../_models/user-list.model';
import { pluck } from 'rxjs/operators';
import { UserDataModel } from '@modules/auth';

const API_USERS_URL = `${environment.apiUrl}`;

@Injectable({
  providedIn: 'root',
})
export class AdminHTTPService {

  constructor(private http: HttpClient) {
  }

  createGroup(params: {
    groupName: string,
    description: string,
    groupPicture: string,
    groupPictureFileName: string,
    isPrivate: boolean
  }): Observable<ResponseModel<boolean>> {
    return this.http.post<ResponseModel<boolean>>(`${API_USERS_URL}/v1/Group/create-group`, params);
  }

  getAllRequests(pageNumber: number, pageSize: number, searchKey: string): Observable<PagedResponseModel<JoinGroupResponseModel>> {
    const params = new HttpParams()
      .set('pageNumber', pageNumber.toString())
      .set('pageSize', pageSize.toString())
      .set('searchKey', searchKey.toString());
    return this.http.get<PagedResponseModel<JoinGroupResponseModel>>(`${API_USERS_URL}/v1/Group/get-private-group-requests`, {params});
  }

  loginAsUser(behalfOfUser: string): Observable<ResponseModel<UserDataModel>> {
    return this.http.post<ResponseModel<UserDataModel>>(`${API_USERS_URL}/v1/User/login-as-user`, {behalfOfUser});
  }

  joinRequestResult(id: number, isApproved: boolean): Observable<ResponseModel<boolean>> {
    return this.http.put<ResponseModel<boolean>>(`${API_USERS_URL}/v1/Group/join-request-result`, {id, isApproved});
  }

  getAllUsers(pageNumber: number, pageSize: number, searchKey: string): Observable<PagedResponseModel<UserListModel>> {
    const params = new HttpParams()
      .set('pageNumber', pageNumber.toString())
      .set('pageSize', pageSize.toString())
      .set('searchKey', searchKey);
    return this.http.get<PagedResponseModel<UserListModel>>(`${API_USERS_URL}/v1/User/get-all-users`, {params});
  }

  getGroupAllUsers(pageNumber: number, pageSize: number, groupId: number): Observable<UserListModel[]> {
    const params = new HttpParams()
      .set('pageNumber', pageNumber.toString())
      .set('pageSize', pageSize.toString())
      .set('groupId', groupId.toString());
    return this.http.get<PagedResponseModel<UserListModel>>(`${API_USERS_URL}/v1/User/get-all-users`, {params}).pipe(pluck('data'));
  }

  addUserToGroup(groupId: number, userId: string) {
    return this.http.post<any>(`${API_USERS_URL}/v1/Group/add-user-group`, {groupId, userId });
  }

  removeUserFromGroup(groupId: number, userId: string) {
    return this.http.delete<any>(`${API_USERS_URL}/v1/Group/remove-user-group`, {
      body: {
        groupId,
        userId,
      }
    });
  }

  changeActivationOfUser(email: string, enabled: boolean): Observable<ResponseModel<boolean>> {
    return this.http.post<ResponseModel<boolean>>(`${API_USERS_URL}/v1/User/change-activation-of-user`, {
      email,
      enabled,
    });
  }

  resetPassword(email: string): Observable<ResponseModel<boolean>> {
    return this.http.post<ResponseModel<boolean>>(`${API_USERS_URL}/v1/User/reset-users-password`, {email});
  }

  deleteUserProfile(userId: string): Observable<ResponseModel<boolean>> {
    return this.http.delete<ResponseModel<boolean>>(`${API_USERS_URL}/v1/UserProfile/admin-delete-user-profile/${userId}`);
  }
}
